import React, { Ref, forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useSortableItemContext } from './SortableItemContext';

const useStyles = makeStyles()((theme) => ({
  item: {
    cursor: 'grab',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  },
  isActive: {
    cursor: 'grabbing',
    opacity: 0.5,
  },
  isDragged: {
    cursor: 'grabbing',
  },
}));

type SortableItemProps = Partial<React.HTMLAttributes<HTMLDivElement>> & {
  isDragged?: boolean;
  children?: React.ReactNode;
};

const Item = forwardRef(({ children, ...props }: SortableItemProps, ref) => {
  return (
    <div {...props} ref={ref as Ref<HTMLDivElement>}>
      {children}
    </div>
  );
});

export const SortableItem = ({ isDragged = false, children }: SortableItemProps) => {
  const { classes, cx } = useStyles();

  const { isActive, setNodeRef, style } = useSortableItemContext();

  return (
    <Item
      className={cx(
        classes.item,
        isActive ? classes.isActive : '',
        isDragged ? classes.isDragged : '',
      )}
      ref={setNodeRef}
      style={{ ...style, width: '100%' }}
    >
      {children}
    </Item>
  );
};

export default SortableItem;
